export default {
  internalChatMessages: [],
  isSocketAlreadyListened: false,
  internalChatMessageInfos: null,
  replyinternalChatMessage: null,
  selectInternalChat: {
    user_id: null,
    chats: [],
  },
}